import React, { useState, useEffect } from 'react';
import * as FiIcons from 'react-icons/fi';
import ModuleLayout from '../common/ModuleLayout';

const { FiEdit } = FiIcons;

const ModuleFive = ({ data, onSave, completed }) => {
  const [bookType, setBookType] = useState('nonfiction');
  const [fictionData, setFictionData] = useState({ openingParagraph: '' });
  const [nonfictionData, setNonfictionData] = useState({ openingParagraph: '' });
  const [commitment, setCommitment] = useState({ date: '', time: '', location: '', committed: false });
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (data.bookType) setBookType(data.bookType);
    if (data.fictionData) setFictionData(data.fictionData);
    if (data.nonfictionData) setNonfictionData(data.nonfictionData);
    if (data.commitment) setCommitment(data.commitment);
  }, [data]);

  const handleSave = async (markComplete) => {
    setIsLoading(true);
    const dataToSave = { bookType, fictionData, nonfictionData, commitment };
    setTimeout(() => {
      onSave(dataToSave, markComplete);
      setIsLoading(false);
    }, 800);
  };

  const currentPara = bookType === 'fiction' ? fictionData.openingParagraph : nonfictionData.openingParagraph;
  const canComplete = currentPara && currentPara.trim() !== '' && commitment.committed;

  return (
    <ModuleLayout
      title="Kickstart the First Chapter"
      description="Break the blank page and begin writing today."
      icon={FiEdit}
      onSave={handleSave}
      completed={completed}
      canComplete={canComplete}
      isLoading={isLoading}
    >
      <div className="space-y-8">
        <div className="bg-white rounded-2xl shadow-sm p-8 border border-slate-100">
          <label className="block text-lg font-bold text-slate-800 mb-4">Opening Paragraph Draft</label>
          <textarea
            value={currentPara}
            onChange={(e) => {
              const val = e.target.value;
              if (bookType === 'fiction') setFictionData({ openingParagraph: val });
              else setNonfictionData({ openingParagraph: val });
            }}
            rows={8}
            className="w-full p-4 bg-slate-50 border border-slate-100 rounded-xl focus:ring-2 focus:ring-blue-500 focus:bg-white transition-all resize-none"
            placeholder="Don't worry about perfection—just begin!"
          />
        </div>

        <div className="bg-white rounded-2xl shadow-sm p-8 border border-slate-100">
          <label className="flex items-center cursor-pointer group">
            <input
              type="checkbox"
              checked={commitment.committed}
              onChange={(e) => setCommitment(prev => ({ ...prev, committed: e.target.checked }))}
              className="w-6 h-6 rounded border-slate-200 text-blue-600 focus:ring-blue-500"
            />
            <span className="ml-4 text-lg font-bold text-slate-800 group-hover:text-blue-600 transition-colors">
              I commit to starting before I feel ready.
            </span>
          </label>
        </div>
      </div>
    </ModuleLayout>
  );
};

export default ModuleFive;